<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">征文评审校级管理</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="body-nav column-cen">
											<div class="column-cen">
												<span class="nav-tit">名称：</span>
												<el-input placeholder="请输入作品名称" v-model="input" clearable></el-input>
												<el-button type="primary" style="margin-left: 20px;" @click="getTable">查询</el-button>
											</div>
											<div class="column-cen topic">
												<span>本次审核截止：</span>
												<span class="red-text">{{ isEndTime }}</span>
											</div>
										</div>
										<el-table id="table" :header-cell-style="tableStyle" border :data="topicSumData" style="width: 100%;margin-bottom: 20px;">
											<el-table-column prop="title" label="作品名称" width="350">
												<template slot-scope="scope">
													<div style="color:#409eff;cursor: pointer;" @click="goRoute(`/backstage/submitteInfo?id=${scope.row.id}&auditType=${2}`)">
														{{ scope.row.title }}
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="author" label="作者">
												<template slot-scope="scope">
													{{ scope.row.author }},{{ scope.row.record }}
												</template>
											</el-table-column>
											<el-table-column prop="projectTypeId" label="作品类型" width="100"></el-table-column>
											<el-table-column prop="learningSectionString" label="学段" width="100"></el-table-column>
											<el-table-column prop="disciplineIdString" label="学科" width="100"></el-table-column>
											<el-table-column prop="createTime" label="上传时间"></el-table-column>
											<el-table-column prop="state" label="审核状态" width="100">
												<template slot-scope="scope">
													{{ scope.row.autoState | rowState }}
												</template>
											</el-table-column>
											<el-table-column prop="projectUnitName" label="操作" width="70">
												<template slot-scope="scope">
													<el-button
														v-if="scope.row.state == 0 && endTrue"
														type="text"
														@click="goRoute(`/backstage/submitteInfo?id=${scope.row.id}&autoState=${1}&auditType=${2}`)"
													>
														审核
													</el-button>
													<el-button v-if="scope.row.state == 2 && endTrue" type="text" @click="submitBtn(scope.row)">撤回</el-button>
												</template>
											</el-table-column>
										</el-table>
										<div class="pagination">
											<el-pagination
												@size-change="handleSizeChange"
												@current-change="handleCurrentChange"
												:current-page="pageNumber"
												:page-sizes="[50, 100, 200]"
												:page-size="pageSize"
												layout="total, sizes, prev, pager, next, jumper"
												:total="underStudyTopicTotal"
											></el-pagination>
										</div>
									</div>
									<!-- end card-body-->
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getPageListReview, schoolAudit, getReviewInfo } from '@/api/after/newInterface.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			topicSumData: [],
			underStudyTopicTotal: 10,
			pageNumber: 1,
			pageSize: 20,
			input: '',
			ids: '',
			isEndTime: '',
			endTrue: true
		};
	},
	filters: {
		rowState(val) {
			if (val == 0) {
				return '待审核';
			}
			if (val == 1) {
				return '初审不通过';
			}
			if (val == 2) {
				return '初审通过';
			}
			if (val == 3) {
				return '终审不通过';
			}
			if (val == 4) {
				return '终审通过';
			}
		}
	},
	created() {
		this.ids = this.$route.query.id;
		this.getTable();
		this.getInfo();
	},
	methods: {
		getInfo() {
			getReviewInfo(this.ids).then(res => {
				this.isEndTime = res.data.trialEndTime;
				var payTimeEnd = new Date(this.isEndTime).getTime(); //获取到的是 毫秒级别的

				var newData = Date.parse(new Date()); // 获取当前时间，也是 毫秒级别的
				if (newData > payTimeEnd) {
					this.endTrue = false;
				}
			});
		},
		submitBtn(row) {
			let params = {
				auditType: 2,
				declareId: row.id,
				auditState: 0,
				type: 1
			};
			schoolAudit(params).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
					this.getTable();
				} else {
					this.$message.error(res.data);
				}
			});
		},
		handleSizeChange(val) {
			this.pageSize = val;
		},
		handleCurrentChange(val) {
			this.pageNumber = val;
		},
		goRoute(url) {
			this.$router.push(url);
		},
		getTable() {
			let params = {
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				title: this.input,
				projectId: this.$route.query.id,
				un: true
			};
			getPageListReview(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	// justify-content: space-between;
}
.pagination {
	display: flex;
	justify-content: center;
}
.body-nav {
	margin-bottom: 20px;
	.nav-tit {
		min-width: max-content;
	}
	.topic {
		margin-left: 50px;
		.red-text {
			color: red;
		}
	}
}
.column-cen {
	display: flex;
	align-items: center;
}
</style>
